/**
 * Hand a file to the browser — ONE definition. Card P179.
 *
 * ⛔⛔ WHY THIS FILE EXISTS. `MetricDrilldown`'s "Export CSV" fetched the file
 * from the server, rendered "Exported 25 rows as drilldown.csv", and **never
 * delivered it**. The server built the CSV, the PHI disclosure audit fired, the
 * UI reported success — and nothing reached the user's disk. Carlos reported it
 * as "Export CSV doesn't work" on 30 Oct; the comment directly above the
 * success banner already said "a silent failure on the path that takes rows out
 * of the building is the worst shape: the user believes they have the file."
 * It was describing itself.
 *
 * ⚠ THE SAVE CODE EXISTED THE WHOLE TIME, in DownloadMenu.js, three files away.
 * That is the shape this repo repeats: not a missing idea, a second place that
 * needed it and did not import it. Both now call this.
 */

/**
 * ⚠ REVOKE ON THE NEXT TICK. Revoking synchronously races the download in
 * Safari and produces a 0-byte file — which looks like a successful export of
 * nothing, the same failure class this module exists to remove.
 */
export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = window.document.createElement('a');
  a.href = url;
  a.download = filename;
  window.document.body.appendChild(a);
  a.click();
  window.document.body.removeChild(a);
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

/**
 * Save server-produced CSV text.
 *
 * ⛔ RETURNS false RATHER THAN THROWING when the environment cannot save (jsdom,
 * a sandbox with no Blob). The caller reports that as a failure instead of
 * claiming success — "I could not hand you the file" is a different sentence
 * from "exported", and conflating them is the original defect.
 */
export function saveCsv(csv, filename) {
  if (typeof window === 'undefined' || typeof window.Blob !== 'function'
      || !window.URL || typeof window.URL.createObjectURL !== 'function') {
    return false;
  }
  // ⚠ BOM first: Excel reads a UTF-8 CSV without one as Latin-1, which mangles
  // every accented patient name in the file.
  saveBlob(new window.Blob(["﻿", csv], { type: 'text/csv;charset=utf-8' }),
           filename || 'export.csv');
  return true;
}
